import { getConfig, klinikenApi } from "@/api";
import { useStore } from "@/store";
import { flashWarning } from "@/utils";

export const personType = "1.2.752.129.2.1.3.1";

export const selectPatient = async ({ patientId, personId }: { patientId?: string; personId?: string }) => {
    const store = useStore();

    try {
        if (patientId) {
            await store.dispatch("patientData/loadFromBackend", {
                id: patientId,
                failSilently: false,
            });

            return patientId;
        }

        if (personId) {
            const response = await klinikenApi.get("core/patienter/", {
                ...getConfig({}),
                params: {
                    personId__icontains: personId,
                    personIdType: personType,
                },
            });

            const retrievedPatientId = response.data.results[0].id;

            await store.dispatch("patientData/loadFromBackend", {
                id: retrievedPatientId,
                failSilently: false,
            });

            return retrievedPatientId;
        }
    } catch (_) {
        flashWarning("Kunde inte hämta patient");
    }
};
